<mat-icon [class]="iconClass" [svgIcon]="icon" [matTooltip]="tooltip"></mat-icon>
